import usePanel from '@databases/panel/usePanel';
import { useCallback } from 'react';

import { useViewUiState } from './useViewUiState';

const useViewPanel = () => {
  const { hidePanel } = usePanel();
  const { setActivePanelSetting } = useViewUiState();

  const closeViewSettingsPanel = useCallback(() => {
    hidePanel();
    setActivePanelSetting(null);
  }, [hidePanel, setActivePanelSetting]);

  return {
    closeViewSettingsPanel,
  };
};

export default useViewPanel;
